import {Grid, styled, TextField} from "@mui/material";
import React from "react";
import {Controller, SubmitHandler, useForm} from "react-hook-form";
import MWCaption from "../../components/MWCaption";

import {Box} from "@mui/system";
import {useRecoilValue, useSetRecoilState} from "recoil";
import * as MaintenanceApi from "../../api/workOrderApi/MaintenanceApi";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import SubTitle from "../../components/SubTitle";
import {useUpdateMutation} from "../../hooks/useQueryHooks";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {FormSection} from "../../styledComponents/StyledCreateForm";

import SlowMotionVideoIcon from "@mui/icons-material/SlowMotionVideo";
import {useQueryClient} from "react-query";
import {useLocation, useNavigate} from "react-router-dom";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";
import {EQWorkOrder, initializeWorkOrder} from "../../models/serverModels/workOrder/EQWorkOrder";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";

const CategoryFormContainer = styled(Grid)(({theme}) => ({
  justifyContent: "center",
  alignItems: "center",
  marginTop: "16px",

  backgroundColor: "#fff",
  "& p": {
    marginTop: "8px",
  },
}));

const CategoryFormContent = styled(Grid)(({theme}) => ({
  display: "flex",
  flexFlow: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  margin: "48px 0",

  padding: "36px",
  border: `1px solid ${theme.palette.background.paper}`,
  borderRadius: "16px",
  boxShadow:
    "rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem",

  "& label": {
    fontWeight: 600,
    paddingRight: "8px",
  },
}));

const DocumentList = styled(Box)(({theme}) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  "& label": {
    flexBasis: "30%",
  },
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));

const WorkOrderDelay = () => {
  const tokenState = useRecoilValue(tokenSelector);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const {state} = useLocation();

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<EQWorkOrder>,
    Params.Update<EQWorkOrder>
  >({
    api: MaintenanceApi.delayWorkOrder,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");

        navigate(-1);
        queryClient.invalidateQueries("MaintenanceList");
      },
    },
  });

  const {control, handleSubmit} = useForm<EQWorkOrder>({defaultValues: initializeWorkOrder});

  const onSubmit: SubmitHandler<EQWorkOrder> = (data) => {
    updateMutate({
      token: tokenState,
      item: {...initializeWorkOrder, ...data, uid: state.uid},
    });
  };

  return (
    <React.Fragment>
      <SubTitle subTitle="설비 점검 지연" />
      {isUpdateLoading && <MWProgress />}
      <FormSection>
        <form onSubmit={handleSubmit(onSubmit)}>
          <MWCaption title="설비 점검 지연" color="#865619" icon={<SlowMotionVideoIcon />} />
          <CategoryFormContainer container>
            <CategoryFormContent
              item
              xs={12}
              sm={12}
              md={6}
              xl={4}
              sx={{padding: {xs: "16px 4px", sm: "16px 8px", md: "24px"}}}
            >
              <Controller
                name="delayContent"
                control={control}
                render={({field, fieldState: {error}}) => (
                  <DocumentList>
                    <label htmlFor="delayContent">지연 : </label>

                    <TextField
                      {...field}
                      id="delayContent"
                      size="small"
                      placeholder="지연"
                      margin="dense"
                      helperText={error?.message}
                      autoFocus
                      sx={{width: "100%"}}
                    />
                  </DocumentList>
                )}
              />
            </CategoryFormContent>
          </CategoryFormContainer>
          <ConfirmButtonGroup
            link={
              state.list === "Received" ? `/WorkOrder/List/Received` : `/WorkOrder/List/Processed`
            }
            cancelText="취소"
            confirmText="지연"
          />
        </form>
      </FormSection>
    </React.Fragment>
  );
};

export default WorkOrderDelay;
